import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { apiClient } from '@/api/client'

export function useUserProfile() {
  const { user, getAccessTokenSilently } = useAuth0()

  const { data: profile, isLoading, refetch } = useQuery({
    queryKey: ['user-profile', user?.sub],
    queryFn: async () => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.get('/auth/profile')
      return response.data
    },
    enabled: !!user,
  })

  return {
    profile,
    isLoading,
    needsOnboarding: profile && !profile.has_completed_onboarding,
    refetch,
  }
}

export function useUpdateProfile() {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: {
      nickname?: string
      profile_picture_url?: string
      has_completed_onboarding?: boolean
    }) => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.patch('/auth/profile', data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-profile'] })
      queryClient.invalidateQueries({ queryKey: ['teams'] })
      queryClient.invalidateQueries({ queryKey: ['team-users'] })
    },
  })
}

